import { IResourceComponentsProps } from "@refinedev/core";

const ConsigneList: React.FC<IResourceComponentsProps> = () => {
  return (
    <iframe
      src="https://statistiques.lincassable.com/public/dashboard/a74d0942-cce8-485a-94a8-2c115632e284"
      frameBorder="0"
      width="100%"
      height="800"
      allowTransparency
    ></iframe>
  );
};

export default ConsigneList;
